import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ProductRequest} from "../models/productRequest";
import {ProductResponse} from "../models/productResponse";
import {Page} from "../interface/hashtag";
import {ProductImagesRequest} from "../models/productImagesRequest";
import {ProductEditRequest} from "../models/payment/productEditRequest";
import {LanguageVariations} from "../layouts/language-selector/language-uppercase.enum";

@Injectable({
  providedIn: "root"
})
export class ProductService {

  private readonly ENDPOINT_URL = `${environment.apiUrl}/products`;

  constructor(private http: HttpClient) {
  }

  public save(productRequest: ProductRequest, files: Array<File>): Observable<void> {
    const formData = new FormData();

    formData.append('productRequest', new Blob([JSON.stringify(productRequest)], { type: 'application/json' }));

    files.forEach((file) => {
      formData.append(`imageFiles`, file, file.name);
    });

    return this.http.post<void>(this.ENDPOINT_URL, formData);
  }

  public edit(id: bigint, request: ProductEditRequest): Observable<void> {
    const url = `${this.ENDPOINT_URL}/${id}`;
    return this.http.put<void>(url, request);
  }

  public updateProductImages(id: bigint, imagesRequest: ProductImagesRequest): Observable<void> {
    const url = `${this.ENDPOINT_URL}/${id}/images`;
    const formData = new FormData();

    formData.append('imgUrlsForDelete', new Blob([JSON.stringify({imgUrlsForDelete: imagesRequest.imgUrlsForDelete})], { type: 'application/json' }));

    if(imagesRequest.newImgList.length) {
      imagesRequest.newImgList.forEach(file => {
        formData.append('newImgList', new Blob([file], {type: 'multipart/form-data'}));
      });
    }

    return this.http.patch<void>(url, formData);
  }

  public getAll(page: number): Observable<Page<ProductResponse>> {
    const url = `${this.ENDPOINT_URL}?page=${page}`;
    return this.http.get<Page<ProductResponse>>(url);
  }

  public getPictureByName(fileName: string): Observable<Blob> {
    const body = {
      fileName: fileName
    }
    const url = `${this.ENDPOINT_URL}/picture`;

    return this.http.post<Blob>(url, body, {responseType: 'blob' as 'json'});
  }

  public getProductRequest(id: bigint): Observable<ProductRequest> {
    const url = `${this.ENDPOINT_URL}/product-request/${id}`;
    return this.http.get<ProductRequest>(url);
  }

  public delete(id: number): Observable<void> {
    const url = `${this.ENDPOINT_URL}/${id}`;
    return this.http.delete<void>(url);
  }

  getActiveProducts(page: number, pageSize: number, languageCode?: string, isActive?: boolean): Observable<Page<ProductResponse>> {
    const params: { [key: string]: any } = {
      page: page,
      size: pageSize,
      isActive: isActive !== undefined ? isActive : null,
      languageCode: languageCode || LanguageVariations.EN,
    };
    return this.http.get<Page<ProductResponse>>(`${this.ENDPOINT_URL}`, {params});
  }
}
